import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Button, Paper, Alert, Stack, useTheme } from '@mui/material';
import { LockClockOutlined, ExitToAppOutlined, ArrowBackIosNewOutlined } from '@mui/icons-material';

const UnauthorizedPage = () => {
  const navigate = useNavigate();
  const theme = useTheme();

  //REDIRECCION
  React.useEffect(() => {
    const timer = setTimeout(() => {
      navigate(-1, { replace: true });
    }, 15000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Box
      sx={{
        marginTop: "100px",
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        pb:{md: 5},
        pt:{md:1}
      }}
    >
      <Paper
        elevation={24}
        sx={{
          p: { xs: 4, sm: 6, md: 8 },
          maxWidth: 500,
          width: '100%',
          textAlign: 'center',
          borderRadius: 4,
          boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
        }}
      >
        {/* ICONO CENTRAL */}
        <Box sx={{ mb: 4 }}>
          <LockClockOutlined 
            sx={{ 
              fontSize: { xs:70, sm: 90 }, 
              color: 'warning.main',
              mx: 'auto',
              display: 'block'
            }} 
          />
        </Box>

        {/* TITULO */}
        <Typography 
          variant="h4" 
          sx={{ 
            mb: 1, 
            fontWeight: 700,
            background: `linear-gradient(45deg, ${theme.palette.warning.main}, ${theme.palette.warning.dark})`,
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text'
          }}
        >
          ACCESO NO AUTORIZADO
        </Typography>

        {/* MENSAJE */}
        <Typography 
          variant="body1" 
          color="text.secondary" 
          sx={{ mb: 3, lineHeight: 1.5, fontWeight: 500}}
        >
          NO TIENES PERMISOS PARA ACCEDER A ESTE SECCIÓN
        </Typography>

        {/* ALERTA*/}
        <Alert 
          severity="warning" 
          variant="outlined"
          sx={{ 
            mb: 4, 
            justifyContent: 'center',
            '& .MuiAlert-icon': { fontSize: 24 }
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            PONTE EN CONTACTO CON EL ADMINISTRADOR, SI CREES QUE ES UN ERROR
          </Typography>
        </Alert>

        {/* CONTADOR */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="body1" color="text.secondary">
           REDIRIGIENDO EN
          </Typography>
          <Typography 
            variant="h4" 
            sx={{ 
              fontWeight: 'bold',
              color: theme.palette.warning.main,
              fontFamily: 'monospace'
            }}
          >
            <CountdownTimer/>
          </Typography>
        </Box>

        {/* BOTON */}
        <Stack 
          direction={{ xs: 'column', sm: 'row' }} 
          spacing={2} 
          justifyContent="center"
          sx={{ mt: 4 }}
        >
          <Button
            variant="outlined"
            size="large"
            fullWidth
            onClick={() => navigate(-1, { replace: true })}
            startIcon={<ExitToAppOutlined />}
            sx={{ 
              py: 1.5,
              fontWeight: 600,
              borderRadius: 3
            }}
          >
            VOLVER ATRÁS
          </Button>
        </Stack>

        {/* FOOTER */}
        <Box sx={{ mt: 6, pt: 4, borderTop: 1, borderColor: 'divider' }}>
          <Typography variant="body2" color="text.secondary">
            SISTEMA DE INVENTARIOS MUNICIPAL • {new Date().getFullYear()}
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

// Componente contador
const CountdownTimer = ({ initial = 15 }) => {
  const [seconds, setSeconds] = React.useState(initial);

  React.useEffect(() => {
    if (seconds > 0) {
      const timer = setTimeout(() => setSeconds(seconds - 1), 1000);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, [seconds]);

  return seconds;
};

export default UnauthorizedPage;